import { configureStore } from "@reduxjs/toolkit";
import RootReducer from "./reducers";

const Store = configureStore({
    reducer: RootReducer,
    devTools: process.env.NODE_ENV !== 'production'
})

export default Store;